import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit } from "@angular/core";
import { WebhookCommonComponent } from "../common.components";

@Component({
    selector: 'webhook-form-divider',
    templateUrl: './webhook-form-divider.component.html',
    styleUrl: './webhook-form-divider.component.scss',
    standalone: false
})

export class WebhookFormDividerComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
    


}